<template>
  <uni-popup ref="popupRef" class="c-popup-center" type="center" :mask-click="false" @change="handleChange">
    <slot />

    <view v-if="hasClose" class="c-popup-center__close">
      <c-img class="c-popup-center__close-img" remote-name="popup_close" @click="handleClose" />
    </view>
  </uni-popup>
</template>

<script setup lang="ts">
import { CANCEL_EVENT, CHANGE_EVENT } from '@/constants';
import { onBeforeUnmount, ref, toRefs } from 'vue';
import { useAppStore } from '@/store';

interface Props {
  hasClose?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  hasClose: true,
});
const { hasClose } = toRefs(props);

const appStore = useAppStore();

const popupRef = ref(null);
const isOpen = ref(false);

const emits = defineEmits([CANCEL_EVENT, CHANGE_EVENT]);

const handleChange = (e: AnyObject) => {
  if (e.show) {
    isOpen.value = true;
    appStore.incrementPopupCount();
    emits(CHANGE_EVENT, e.show);
  } else {
    isOpen.value = false;
    appStore.decrementPopupCount();
    setTimeout(() => {
      emits(CHANGE_EVENT, e.show);
    }, 200);
  }
};

const handleClose = () => {
  close();
  emits(CANCEL_EVENT);
};

const open = () => popupRef.value?.open();

const close = () => popupRef.value?.close();

defineExpose({
  open,
  close,
});

/** 组件卸载前，把滚动锁定标识置为false */
onBeforeUnmount(() => {
  if (isOpen.value) {
    appStore.decrementPopupCount();
  }
});
</script>

<style scoped lang="scss">
.c-popup-center {
  position: relative;
  z-index: 9991;

  .c-popup-center__close {
    display: flex;
    justify-content: center;
    margin-top: 60rpx;

    .c-popup-center__close-img {
      display: block;
      width: 60rpx;
      height: 60rpx;
    }
  }
}
</style>
